import {getNotification} from '@/helper'
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'

const notificationStore = {
  state: {
    notifications: [],
    totalNotificationsCountIncludeAcknowledged: null
  },
  getters: {
    notificationCount: state => {
      //let count = state.notifications.length
      let count = state.totalNotificationsCountIncludeAcknowledged
      return count
    },
    recentNotificationsCount: (state, getters) => {
      let count = getters.recentNotifications.length
      return count
    },
    recentNotifications: state => {
      return _.filter(state.notifications, function(x) {
        return (!x.acknowledged)
      })
    },
    lowSeverityNotificationsCount: state => {
      return _.filter(state.notifications, function(x) {
        return (!x.acknowledged&&x.severity.toLowerCase()==="low")
      }).length
    },
    mediumSeverityNotificationsCount: state => {
      return _.filter(state.notifications, function(x) {
        return (!x.acknowledged&&x.severity.toLowerCase()==="medium")
      }).length
    },

      criticalSeverityNotificationsCount: state => {
        return _.filter(state.notifications, function(x) {
          return (!x.acknowledged&&x.severity.toLowerCase()==="critical")
        }).length
      },
      highSeverityNotificationsCount: state => {
        return _.filter(state.notifications, function(x) {
          return (!x.acknowledged&&x.severity.toLowerCase()==="high")
        }).length
      },
    importantNotificationsCount: state => {
      return _.filter(state.notifications, function(x) {
        return (!x.acknowledged&&!(x.topic==="anomaly"||x.title.toLowerCase().startsWith("anomaly"))&&(x.severity.toLowerCase()==="critical"||x.severity.toLowerCase()==="high"||x.severity.toLowerCase()==="medium"))
      }).length
    }
  },
  actions: {
    async refreshNotification (context, payload) {
      // payload is a dict with facility_name and ignore_acknowledged
        let maxDate=moment()
        if(context.rootState.pointsListStore.pointsList.data_max_date){
           maxDate=moment(context.rootState.pointsListStore.pointsList.data_max_date)
        }
      // get update from DB
       let notifications =  await getNotification({
          'facility_name': payload['facility_name'],
          'ignore_acknowledged': payload['ignore_acknowledged'],
         'date_range': [moment(maxDate).subtract(90, "days").format('YYYY-MM-DD'),moment(maxDate).format('YYYY-MM-DD')+" 23:59:59"]
        })
        let output = []

        for (let i in notifications['result']) {
          output.push({
            icon: 'fa-bell',
            alertType: notifications['result'][i]['model'],
            title: notifications['result'][i]['title'],
            equip: notifications['result'][i]['equipment_name'],
            equipType: notifications['result'][i]['equipment_type'],
            floor: notifications['result'][i]['floor'],
            startDate: notifications['result'][i]['start_date'],
            endDate: notifications['result'][i]['end_date'],
            topic: notifications['result'][i]['topic'],
            occurredTimes: notifications['result'][i]['occurred_times'],
            to: notifications['result'][i]['to'],
            description: notifications['result'][i]['description'],
            recommendedActions: notifications['result'][i]['recommended_actions'],
            severity: notifications['result'][i]['severity'],
            notification_id: notifications['result'][i]['notification_id'],
            acknowledged: notifications['result'][i]['acknowledged'],
            ack_by: notifications['result'][i]['ack_by'],
            last_ack_date: notifications['result'][i]['last_ack_date'],
            muted_by: notifications['result'][i]['muted_by'],
            muted_date: notifications['result'][i]['muted_date'],
          })
        }

        context.commit('updateNotification', output)
        context.commit('updateTotalNumber', notifications['total_number_with_acknowledged'])
    }
  },
  mutations: {
    updateNotification (state, payload) {
      Vue.set(state, 'notifications', payload)
    },
    updateTotalNumber (state, payload) {
      state.totalNotificationsCountIncludeAcknowledged = payload
    }
  }
}

export default notificationStore
